import React, { useEffect, useState } from "react";
import { useDayPicker } from "@daypicker/react";
import { format } from "date-fns";

export function DayPickerHeader() {
	const { goToMonth, nextMonth, previousMonth, selected } = useDayPicker<{
		mode: "single";
	}>();
	const [displayedDate, setDisplayedDate] = useState(
		format(selected || new Date(), "MMMM yyyy"),
	);

	const handleDateChange = (date?: Date) => {
		const newDate = date || new Date();
		setDisplayedDate(format(newDate, "MMMM yyyy"));
	};

	useEffect(() => {
		handleDateChange(selected);
	}, [selected]);

	const handlePrevMonthClick = () => {
		previousMonth && goToMonth(previousMonth);
		handleDateChange(previousMonth);
	};

	const handleNextMonthClick = () => {
		nextMonth && goToMonth(nextMonth);
		handleDateChange(nextMonth);
	};

	return (
		<div className="rdp-nav">
			<button
				type="button"
				className="rdp-navigation rdp-navigation--previous"
				disabled={!previousMonth}
				onClick={handlePrevMonthClick}
			>
				Previous Month
			</button>

			<div className="rdp-current-month">{displayedDate}</div>

			<button
				type="button"
				className="rdp-navigation rdp-navigation--next"
				onClick={handleNextMonthClick}
				disabled={!nextMonth}
			>
				Next Month
			</button>
		</div>
	);
}
